// Visual-only disable: the design-system Button's native `disabled` sets
// `pointer-events-none`, which would also suppress the tooltip's hover — the
// tooltip is how the user learns *why* the action is unavailable. So callers
// keep this off the `disabled` prop and have their click handlers refuse to act.
export const disabledButtonClassName =
  'cursor-not-allowed text-text-disabled hover:bg-transparent hover:text-text-disabled';
